import { inject, Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { Uuid } from '../../../../../../../graphql';
import { GLOBAL_GRAPHQLGATEWAY_NAME_NO_OVERLAY } from '../../../../../../graphql.module';
import { UpdateContactEmail } from './mutations/UpdateContactEmail.generated';
import { SearchContacts, SearchContactsResult } from './queries/SearchContacts.generated';

export type JobCrewContact = NonNullable<NonNullable<SearchContactsResult['contacts']>['items']>[number];

@Injectable({ providedIn: 'root' })
export class JobCrewContactsApiService {
    #apollo = inject(Apollo);
    get #gql() {
        return this.#apollo.use(GLOBAL_GRAPHQLGATEWAY_NAME_NO_OVERLAY);
    }

    searchContacts(searchText: string, skip: number, take: number) {
        return this.#gql.query({
            query: SearchContacts,
            variables: { searchText, skip, take },
            fetchPolicy: 'no-cache',
            errorPolicy: 'all',
        });
    }

    updateContactEmail(contactId: Uuid, email: string) {
        return this.#gql.mutate({
            mutation: UpdateContactEmail,
            variables: { contactId, email },
            fetchPolicy: 'no-cache',
            errorPolicy: 'all',
        });
    }
}
